/** 首页 */
// 首页-数据概况
export const HOME_VIP_BOARD_INDEX = '/ccrm2/vipBoard/index';
// 首页-折线图
export const HOME_INDEX_LINE_CHART = '/ccrm2/vipBoard/indexLineChart';
